import { user } from "./user";
import { drafts } from "./drafts";
import { applications } from "./applications";
import { request } from "./request";
import { environment } from "./admin/environment";
import { category } from "./admin/category";
import { systemtype } from "./admin/systemtype";
import { employee } from "./admin/employee";
import { gsap } from "./admin/gsap";
import { workday } from "./admin/workday";
import { approver } from "./approvers";
import { salesforceprofile } from "./admin/salesforceprofile";
import { salesforcerole } from "./admin/salesforcerole";
import { systemappname } from "./admin/systemappname";
import { subcategoryapprover } from "./admin/subcategoryapprover";
import { infrastructure } from "./admin/infrastructure";
import { accessadmin } from "./admin/accessadmin";
import { maintenancerole } from "./admin/maintenancerole";
import { infraapp } from "./admin/infraapp";
import { approverDistro } from "./admin/approverdistro";
import { feedback } from "./admin/feedback";
import { vip } from "./admin/vip";

export * from "./dashboard";
export * from "./form";
export * from "./getApplications";
export * from "./getDirectory";
export * from "./getDrafts";
export * from "./getEnvironments";
export * from "./getSystemTypes";
export * from "./getEmployees";
export * from "./getCategories";
export * from "./getInfrastructureApplications";
export * from "./getRequests";
export * from "./getRoles";
export * from "./getSession";
export * from "./getSetting";
export * from "./getUserID";
export * from "./getUsers";
export * from "./getVIPs";
export * from "./postRequest";
export * from "./putRating";
export * from "./requests";
export * from "./submitRating";
export * from "./types";
export * from "./postFeedback";
export * from "./getFeedback";
export * from "./getLandingZoneRoles";

const Api = {
  user,
  drafts,
  applications,
  request,
  environment,
  category,
  systemtype,
  employee,
  gsap,
  approver,
  salesforceprofile,
  salesforcerole,
  systemappname,
  subcategoryapprover,
  infrastructure,
  accessadmin,
  maintenancerole,
  infraapp,
  approverDistro,
  workday,
  feedback,
  vip,
};

export { Api };

export default Api;
